import { PlayerModel } from '@clsplus/cls-plus-data-models'
import { types } from 'mobx-state-tree'

const PlayersSearchMap = types.model('PlayersSearchMap', {
  teamId: types.identifier,
  data: types.array(PlayerModel),
})

export default PlayersSearchMap
